import React from 'react';
import T from 'prop-types';

import Button from '../../../../Buttons/Button';
import ExportSettingsPreview from '../ExportSettingsPreview';

const FREQUENCY_DESCRIPTIONS = {
  weekly: 'Weekly (runs on Monday with data through Sunday of previous week)',
  monthly: 'Monthly (first day of month with data through last day of previous month)',
  quarterly:
    'Quarterly (first day of calendar quarter with data through last day of previous calendar quarter)',
};

const ConfirmationModalContent = ({ isProcessing, setStep, report, onConfirm }) => (
  <>
    <div className="schedule-export-modal__content">
      <ExportSettingsPreview report={report} />
    </div>
    <div className="schedule-export-modal__schedule-info">
      <div className="schedule-export-modal__schedule-info-title">Schedule</div>
      <div className="schedule-export-modal__schedule-info-description">
        {FREQUENCY_DESCRIPTIONS[report.frequency] || report.frequency}
      </div>
    </div>
    <div className="schedule-export-modal__footer">
      <Button variant="secondary" size="lg" onClick={() => setStep('form')}>
        Back
      </Button>
      <Button size="lg" loading={isProcessing} disabled={isProcessing} onClick={onConfirm}>
        {report.id ? 'Schedule Export' : 'Schedule & Run Export'}
      </Button>
    </div>
  </>
);

ConfirmationModalContent.propTypes = {
  isProcessing: T.bool.isRequired,
  setStep: T.func.isRequired,
  report: T.object.isRequired,
  onConfirm: T.func.isRequired,
};

export default ConfirmationModalContent;
